module.exports = __webpack_public_path__ + "static/media/layers.c1a8c567.svg";